export default __webpack_public_path__ + "static/media/weather-icon.dfb71ddf.png";